import { useEffect } from "react";
import "./HeadLine.scss";
import ScrollToTopOnMount from './ScrollToTopOnMount';


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const HeadLine = (props) => {

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the window when the component mounts
  }, []); // Empty dependency array ensures the effect runs only once when the component mounts

  return (
    <div className="flex flex-auto flex-col md:flex-row">
      <ScrollToTopOnMount /> {/* Scroll to top when HeadlineComponent mounts */}

      <div className="mb-3 sm:mb-6">
        <h1 class="font-medium sm:text-4xl bg-transparent text-2xl" style={{
          fontFamily: "Norwester, sans-serif",
          textTransform: "uppercase",
          fontStyle: "normal",
        }}>
          JAZZ FORUM ARTS PROGRAMMING
        </h1>
      </div>
    </div>
  );
};
